/**
 * The app's one JSON fetcher.
 *
 * Its own module rather than a private function in `queries.ts`, because
 * `intraday.ts` needs it too and `queries.ts` is 437 lines: past the 400-line
 * mark where CLAUDE.md rule 7 stops anyone editing a file without an approved
 * split plan. Extracting the leaf is what that rule wants, and it makes the
 * file smaller rather than larger.
 *
 * `credentials: "same-origin"` is what sends the session cookie. A throw on a
 * non-2xx is what puts TanStack Query into its error state; returning the body
 * would render a 500's HTML into a table.
 *
 * `signal` is TanStack Query's, passed through so a query the page no longer
 * wants (a control changed, the component unmounted) cancels its request
 * rather than finishing a read nobody will show.
 */
export async function getJson<T>(path: string, signal?: AbortSignal): Promise<T> {
  const init: RequestInit = { credentials: "same-origin" };
  if (signal) init.signal = signal;
  const response = await fetch(path, init);
  if (!response.ok) {
    throw new Error(`${path} returned ${response.status}`);
  }
  return (await response.json()) as T;
}
